<template>
<table>
  <tr>
    <th v-for="head in headings" :key="head">{{ head }}</th>
  </tr>
  <slot></slot>
</table>
</template>

<script>
export default {
  name: "TableView",
  props: {
    headings: Array,
    width: String
  },
};
</script>
<style scoped>
th {
  text-align: left;
  width: 20%;

}

tr {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}

table {
  display: flex;
  flex-direction: column;
}

@media (max-width: 30em) {
  tr {
    width: 100vw;
  }
}

</style>